import React from 'react';
export var PermissionsCtx = React.createContext(['']);
//# sourceMappingURL=permissions-ctx.js.map